<template>
    <div class="model-info">
        <div class="topic mb-3 hidden-xs-down">
            <h4>Modelo: {{ currentModel.nome }}</h4>
            <p v-if="currentModel.idade && currentModel.idade > 0">
                Idade: {{ currentModel.idade }} anos
            </p>
            <p v-if="currentModel.altura && currentModel.altura > 0">
                Altura: {{ parseFloat(currentModel.altura / 100).toFixed(2) }} m
            </p>
            <p v-if="currentModel.busto && currentModel.busto > 0">
                Busto: {{ currentModel.busto }} cm
            </p>
            <p v-if="currentModel.cintura && currentModel.cintura > 0">
                Cintura: {{ currentModel.cintura }} cm
            </p>
            <p v-if="currentModel.quadril && currentModel.quadril > 0">
                Quadril: {{ currentModel.quadril }} cm
            </p>
        </div>
        <div class="topic">
            <h4>Produto: {{ getModelName(productModel) }}</h4>
            <h4>Tamanho: {{ sizes[currentDimension.size_id].name }}</h4>
            <p v-if="currentDimension.height !== 0">
                Comprimento: {{ currentDimension.height }} cm
            </p>
            <p v-if="currentDimension.width !== 0">Largura: {{ currentDimension.width }} cm</p>
            <p v-if="currentDimension.hip !== 0">Quadril: {{ currentDimension.hip }} cm</p>
            <p v-if="currentDimension.waist !== 0">Cintura: {{ currentDimension.waist }} cm</p>
            <p v-if="currentDimension.sleeve_length !== 0">
                Comprimento da Manga: {{ currentDimension.sleeve_length }} cm
            </p>
            <p v-if="currentDimension.sleeve_circumference !== 0">
                Circunferência da Manga: {{ currentDimension.sleeve_circumference }} cm
            </p>
            <p v-if="currentDimension.leg_circumference !== 0">
                Circunferência da Perna: {{ currentDimension.leg_circumference }} cm
            </p>

            <img
                :src="`${$scope.CDN_IMAGES}/${productModel.dimension_image_url}?h=250`"
                class="img-responsive d-block entered loaded mb-3 mt-3"
                alt="Tabela de tamanhos"
                style="max-width: 80%; margin-right: -2rem"
            />
            <!--            <p class="mb-3">-->
            <!--                <a href="" class="text-uppercase text-underline">Aprenda a medir sua camiseta</a>-->
            <!--            </p>-->
            <p>Observações:</p>
            <p>As medidas podem variar até 2cm</p>
            <p>Este produto pode encolher em até 5% após a primeira lavagem</p>

            <p class="text-bold mt-4" style="font-size: 1.2rem">Troca Grátis</p>
            <p>Sua primeira troca no site é grátis</p>
        </div>
        <div class="topic-button">
            <a
                class="btn btn-primary margin-left-auto text-uppercase"
                target="_blank"
                :href="`https://chicorei.com/camiseta/tamanho-${
                    sizes[currentDimension.size_id].name
                }/?inPhysicalStock=1`"
            >
                Ver tamanhos {{ sizes[currentDimension.size_id].name }} em estoque
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SizeGuideZoomInfo',

        props: {
            currentModel: {
                type: Object,
                required: true,
            },
            productModel: {
                type: Object,
                required: true,
            },
            currentDimension: {
                type: Object,
                required: true,
            },
            sizes: {
                type: Object,
                required: true,
            },
        },

        methods: {
            getModelName(data) {
                return data.product_type.nome + ' ' + (data.filter_name || '');
            },
        },
    };
</script>
